import { useUBL } from '@common/log-manager';
import { getServerLogForVerticalProductCard, UxGoodsCardItemForVerticalProductCard } from '@common/product-card';

export interface UBLParam {
  position: number;
  group_type: string;
  catalog_product_id: string;
  ad_log?: string;
}

export interface CommonUBLParams {
  position: number;
  groupType: string;
  item: UxGoodsCardItemForVerticalProductCard;
}

export const useRelatedStylistListUBL = (original_product_id: string) => {
  const sendUBL = useUBL();

  const impressionRelatedItem = ({ position, groupType, item }: CommonUBLParams) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'catalog',
      object_section: groupType,
      object_id: item.catalog_product_id || '',
      object_idx: position,
      data: {
        original_product_id,
        server_log: item.log && getServerLogForVerticalProductCard(item.catalog_product_id, item),
      },
    });
  };

  const clickRelatedItem = ({ position, groupType, item }: CommonUBLParams) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'catalog',
      object_section: groupType,
      object_id: item.catalog_product_id || '',
      object_idx: position,
      data: {
        original_product_id,
        server_log: item.log && getServerLogForVerticalProductCard(item.catalog_product_id, item),
      },
    });
  };

  const savedProductRelatedItem = ({
    category,
    position,
    groupType,
    item,
  }: CommonUBLParams & {
    category: 'save_product' | 'remove_saved_product';
  }) => {
    sendUBL({
      category,
      navigation: 'product_detail',
      object_type: 'catalog',
      object_section: groupType,
      object_id: item.catalog_product_id || '',
      object_idx: position,
      data: {
        original_product_id,
        server_log: item.log && getServerLogForVerticalProductCard(item.catalog_product_id, item),
      },
    });
  };

  return {
    impressionRelatedItem,
    clickRelatedItem,
    savedProductRelatedItem,
  };
};
